// Icone padrao de dar baixa em comissao (emseg-icones-sistema/icons/dar-baixa-comissao.svg).
export default function IconDarBaixaComissao({ size = 16, style, ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      role="img" aria-label="Dar baixa em comissão" style={{ display: 'block', ...style }} {...props}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M7 10h4M7 14h3M14 14l1.8 1.8L19 12.5" />
    </svg>
  )
}
